<div class="reward-token-card__top-combined">
    <div class="reward-token-card__header-combined">
        <ng-container [ngTemplateOutlet]="vipBadgeTemplate" />
        <div class="reward-token-card__title">{{ token.customTitle }}</div>
    </div>
    <div class="betandget-category-link">
        <bs-reward-token-categories
            [categories]="tokenCategories"
            [isRewardDrawerEnabled]="isRewardDrawerEnabled"
            [tokenFilter]="token.filter"
            [betType]="betType.length > 0 ? betType[0].value : ''"></bs-reward-token-categories>
        <bs-reward-token-card-info-link
            *ngIf="linkTitle"
            [token]="token"
            [withArrow]="false"
            [overrideLinkTitleHtml]="linkTitle"></bs-reward-token-card-info-link>
    </div>
</div>
<div class="betandget-card__link-group" *ngIf="tokenLimitations.length > 0">
    <bs-reward-token-limitations [limitations]="tokenLimitations" [isRewardDrawerEnabled]="isRewardDrawerEnabled"></bs-reward-token-limitations>
</div>

<div class="reward-token-card__payout-details" *ngIf="showPayout">
    <span class="reward-token-card__payout-title"> {{ tokenPayoutTitle }}&nbsp; </span>
    <span>{{ payoutDetails }}&nbsp;</span>
    @if (isRewardDrawerEnabled) {
        <span class="reward-token-card__token-payout-description">{{ payoutTitle }} </span>
    }
    <ng-container *ngIf="!isRewardDrawerEnabled && token.payoutExpiry">
        <span class="reward-token-card__separator"> | </span>
        <span> {{ expiryDetails }} </span>
    </ng-container>
</div>

<div [class.reward-token-footer-details]="applyRemoveButtonsShowHide()">
    <bs-reward-token-footer-details
        [expireTokenReward]="expireTokenReward"
        [token]="token"
        [promoHubUrlTokenType]="promoHubUrlTokenType"
        [isRewardBannerView]="isRewardBannerView"
        [tokenTitle]="token.customTitle"
        [tokenCategories]="tokenCategories"></bs-reward-token-footer-details>
    @if (applyRemoveButtonsShowHide()) {
        <button ds-button size="small" variant="outline" kind="secondary">
            {{ applyOrRemoveTokenText }}
        </button>
    }
</div>
